export const viewer = {
  strict: true, // true => strict update state from component

  state: {
    viewer: false,
    updatedList: false,
    moving: false,
    iconVisibility: true,
    command: { copy: 0, rotateL: 0, rotateR: 0, delete: 0, tap: 0 },
    confirming: false,
    changeDateFiles: [],
    deletedFiles: [],
  },

  getters: {},

  mutations: {
    OPEN_VIEWER: (state, payload) => {
      state.iconVisibility = true;
      state.viewer = payload;
    },
    UPDATE_VIEWER: (state, payload) => {
      state.updatedList = payload;

      if (!payload || !state.viewer || state.viewer.items.length != 1 || payload.length == 0) {
        console.warn(`viewer data was not updated!`);
        return;
      }
      var items = state.viewer.items;
      var newItems = payload;

      var item = items[0];

      var there = false;
      var prevs = [];
      for (var newItem of newItems) {
        if (there) items.push(newItem);
        if (newItem.id == item.id) {
          there = true;
          continue;
        }
        prevs.unshift(newItem);
      }
      // there is not current item.
      if (!there) return console.warn('there is not self in new items');
      for (var newItem of prevs) {
        items.unshift(newItem);
      }
    },
    MOVING_VIEWER: (state, payload) => {
      state.moving = payload;
    },
    VIEWER_ICON_VISIBILITY: (state, payload) => {
      state.iconVisibility = payload;
    },
    VIEWER_COMMAND: (state, payload) => {
      Object.keys(payload).forEach(function(key) {
        state.command[key] = payload[key];
      });
    },
    VIEWER_CONFIRMING: (state, payload) => {
      state.confirming = payload;
    },
    CLOSE_VIEWER: (state, payload) => {
      state.viewer = false;
    },
    UPDATE_ROTATE_VIEWER_ITEM: (state, payload) => {
      if (!state.viewer) return;
      payload.item.rotate += payload.degree;
    },
    UPDATE_VISIBILITY_VIEWER_ITEM: (state, payload) => {
      if (!state.viewer) return;
      payload.item.visibility = payload.v;
    },
    DELETE_VIEWER_ITEM: (state, payload) => {
      if (!state.viewer) return;
      state.deletedFiles.push(payload);
      var id = payload.id;
      var items = state.viewer.items;
      for (var i = 0, n = items.length; i < n; i++) {
        if (items[i].id == id) {
          items.splice(i, 1);
          return;
        }
      }
    },
    FILE_CLEAR_UPDATED: (state, payload) => {
      state.changeDateFiles = [];
      state.deletedFiles = [];
    },
    UPDATE_DATE_VIEWER_ITEM: (state, payload) => {
      if (!state.viewer) return;
      var item = payload.item;
      var from = item.ts;
      var to = payload.ts;
      item.ts = to;
      item.tz_code = payload.tz;
      console.log(`fid=${item.id} timestamp from=${from} to=${to}`);
      if (from != to) {
        state.changeDateFiles.push({ item: item, from: from, to: to });
      }
    },
  },
};
